import React, { useEffect, useState, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import {
  MDBContainer,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCheckbox
}
  from 'mdb-react-ui-kit';
import styled from 'styled-components';

import axios from 'axios';

import { useNavigate } from 'react-router-dom'; // Import useHistory for navigation

import { selectAuth } from '../../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import Accordion from 'react-bootstrap/Accordion';
import ImageViewer from 'react-simple-image-viewer';


const GreenTab = styled(MDBTabsLink)`
    background-color: green; /* Change to your desired shade of green */
    color: white; /* Change text color if needed */
`;

function Main_nouploads() {

  const [justifyActive, setJustifyActive] = useState('tab1');;
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  let [loadingData, setLoadingData] = React.useState(true);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [images, setImages] = useState([]);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axios.get('/api/defisuploads/nouploads/atall/all');
        if (response.status == 200) {
          console.log(response.data)
          setData(response.data)
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle error appropriately, e.g., show an error message or dispatch a failure action
      } finally {
        setLoadingData(false)
      }

    };
    fetch();
  }, []);

 


  return (
    <Container>
      <h1 className="my-3">No uploads at all</h1>
      {/* <MDBContainer className="p-3 my-5 d-flex flex-column">

      <MDBTabs pills justify className='mb-3 d-flex flex-row justify-content-between'>
        <MDBTabsItem>
          <GreenTab onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'} style={{
            backgroundColor: justifyActive === 'tab1' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab1' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            View by Defis
          </GreenTab>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'} style={{
            backgroundColor: justifyActive === 'tab2' ? 'green' : 'transparent', // Green if active, transparent otherwise
            color: justifyActive === 'tab2' ? 'white' : 'black' // White text if active, black otherwise
          }}>
            View by Patrouilles
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>

      <MDBTabsContent>

        <MDBTabsPane open={justifyActive === 'tab1'}>

       {tab1}

        </MDBTabsPane>

        <MDBTabsPane open={justifyActive === 'tab2'}>

         

        </MDBTabsPane>


      </MDBTabsContent>
    </MDBContainer> */}
      {loadingData ?
        (<></>)
        :
        (<Accordion defaultActiveKey="0">
          {
            data.map((district, index) => {
              return (
                <Accordion.Item eventKey={index}>
                  <Accordion.Header>{district.name}</Accordion.Header>
                  <Accordion.Body>
                    <Accordion defaultActiveKey="0">
                      {
                        district.Troupes.map((troupe, indexx) => {
                          return (
                            <Accordion.Item eventKey={indexx}>
                              <Accordion.Header>
                                {troupe.name ? `${troupe.groupe} - ${troupe.name}` : troupe.groupe}
                              </Accordion.Header>
                              <Accordion.Body>
                                {
                                  troupe.Patrouilles.map((patrouille, indexxx) => {
                                    return (<p>{patrouille.totem}</p>)
                                  })
                                }
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                        })
                      }

                    </Accordion>
                  </Accordion.Body>
                </Accordion.Item>
              )
            })
          }

        </Accordion>
        )
      }
    </Container>
  );
}

const styles = {
  gallery: {
    display: "flex", // Use Flexbox
    flexWrap: "wrap", // Wrap images to the next line if they don't fit
    gap: "10px", // Space between images
  },
  imageContainer: {
    width: "100px", // Fixed width for each image container
    height: "100px",
    overflow: "hidden", // Hide overflow
    borderRadius: "8px", // Optional: Rounded corners
    border: "1px solid #ddd", // Optional: Add a border
  },
  image: {
    width: "100%", // Fill the container
    height: "100%",
    objectFit: "cover", // Ensure the image covers the container
  },
};

export default Main_nouploads;